import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import { useModalContext } from 'Views/Page/Contexts/ModalContext';
import ShoppingCartSelect from 'Components/ComponentLibrary/Organisms/ShoppingCartSelect';
import TitleSection from 'Views/Page/Content/Modal/Components/TitleSection';
import WhatIfStepNavigator from 'Views/Page/Content/Modal/Components/WhatIfStepNavigator';
import fr from 'facet-rest';
import WizardSpecificPageLinkBottom
  from 'Components/ComponentLibrary/Components/Uncategorized/WizardSpecificPageLinkBottom';

const styles = () => ({
  root: {},
  specificPageLink: {
    display: 'flex',
    justifyContent: 'center',
  },
});

const StrategyLauncher = ({
  className,
  classes,
}) => {
  const { onSubmit, saving } = useMetaLayoutContext(); // onSubmit
  const {
    setModalCollection, refreshModalCollection, modalCollection, modalResource, loadModalCollectionByLink,
  } = useModalContext();
  const previousLink = modalResource.relationship(fr.relationships.previousLink.name)?.link('related');

  const resource = modalCollection.resources().head();
  const options = resource.attr('itemGroups').resources().list();

  const specificPageLink = modalResource.relationship(fr.relationships.specificPageLink.name)?.link('related');

  const onClickItem = (nextWizard) => {
    setModalCollection(nextWizard);
  };

  const handlePageBottomLinkClick = async (link) => {
    loadModalCollectionByLink(link.url());
  };

  return (
    <Box
      className={classNames(classes.root, className)}
    >
      <TitleSection />
      <ShoppingCartSelect
        options={options}
        refetchItems={(addResponse) => {
          if (addResponse) {
            setModalCollection(addResponse);
          } else {
            refreshModalCollection();
          }
        }}
        onClickItem={onClickItem}
      />
      <Box
        className={classes.specificPageLink}
      >
        <WizardSpecificPageLinkBottom
          resource={resource}
          onClick={(specificPageLink) ? () => handlePageBottomLinkClick(specificPageLink) : null}
        />
      </Box>
      <WhatIfStepNavigator
        isLoading={saving}
        onNext={() => {
          onSubmit();
        }}
        onPrevious={(previousLink) ? () => {
          loadModalCollectionByLink(previousLink.url());
        } : null}
      />
    </Box>
  );
};

StrategyLauncher.defaultProps = {
  className: '',
};

StrategyLauncher.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(StrategyLauncher);
